import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { StatusBarService } from 'src/services/status-bar-service';
import { TokenStorageService } from 'src/services/token-storage.service';
import { UserService } from 'src/services/user.service';
import { UtilService } from 'src/services/util.service';
import { AddUserComponent } from '../admin/add-user/add-user.component';
import { IUserInfo } from 'src/models/user/user-info.interface';
import { IUserInfoViewResponse } from 'src/models/api-response/user-info-response.interface';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.css'],
    standalone: false
})
export class NavBarComponent implements OnInit {

  innerWidth: number = 0;
  isAdmin: boolean;
  isDeveloper: boolean;
  isAddingUser: boolean;
  myUserId: number;
  myUserInfo: IUserInfo;
  @Output() toggleSideNav = new EventEmitter<void>();

  myProfileImageSafe: SafeUrl | null = null;
  isSupervisor: boolean;
  divid: number;

  constructor(private router: Router, private authService: AuthService, private userService: UserService,
    private utilService: UtilService, private tokenStorageService: TokenStorageService,
    private statusBarService: StatusBarService, private dialog: MatDialog, private readonly sanitizer: DomSanitizer) {
    this.innerWidth = window.innerWidth;
    this.isAdmin = false;
    this.isDeveloper = false;
    this.isAddingUser = false;
    this.isSupervisor =false;
    this.divid=0;
    this.myUserId = -1;
    this.myUserInfo = {
      id: null,
      isAdmin: false,
      isDeveloper: false,
      isActive: false,
      isSupervisor: false,
      name: null,
      firstName: null,
      lastName: null,
      division: null,
      section: null,
      department: null,
      divisionID: null,
      sectionID: null,
      jobTitle: null,
      photo: null,
      photoSafe: null,
      email: null,
      companyName: null,
      companyID: null,
      callSign: null,
      qRCode: null,
      workTime: {
        hours: null,
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        sun: false
      },
      teleWorkData:{
        userinfoid:null,
        startTime:'',
        startAMPM:'',
        endTime:'',
        endAMPM:'',
        poMonday:  false,
        poTuesday:  false,
        poWednesday:  false, 
        poThursday: false,
        poFriday: false,
        poSaturday:false,
        poSunday:false,
        ptMonday: false,
        ptTuesday: false,
        ptWednesday: false,
        ptThursday: false,
        ptFriday: false,
        ptSaturday:false,
        ptSunday:false,
        npoMonday:  false,
        npoTuesday:  false,
        npoWednesday:  false, 
        npoThursday: false,
        npoFriday: false,
        npoSaturday:false,
        npoSunday:false,
        nptMonday: false,
        nptTuesday: false,
        nptWednesday: false,
        nptThursday: false,
        nptFriday: false,
        nptSaturday:false,
        nptSunday:false
      },
      workTimeAndSummary:null,
      payWeekWorkDay:null,
      nonpayWeekWorkDay:null,
      supervisor: null,
      lsdt: [],
      drlist: [],
      upid:null,
      hasTelework:false,
      supervisorid:0,
      todayInOfice:'N'
    };


    this.userService.GetUserRoles(Number(this.tokenStorageService.getUserInfoId()))
    .subscribe(usr => {
      let msg = "User (" + this.tokenStorageService.getUserName()+ ") is " + (usr.isAdmin ? "" : "not ") + "an Admin";
      this.tokenStorageService.saveIsSupervisor(usr.isSuperVisor);
      this.tokenStorageService.saveIsAdmin(usr.isAdmin);
      this.tokenStorageService.saveIsDeveloper(usr.isDeveloper);
      this.isAdmin = usr.isAdmin;
      this.isSupervisor= usr.isSuperVisor;
      this.isDeveloper = usr.isDeveloper;
      this.divid = usr.divisionId==null?0:usr.divisionId;
    });
  }

  ngOnInit(): void {
    this.myUserId = Number(this.tokenStorageService.getUserInfoId());
    this.isAdmin = this.tokenStorageService.isAdmin();
    this.isDeveloper = this.tokenStorageService.isDeveloper();
    this.getProfileThumbnail();
  }

  onLogout(): void {
    this.authService.logout();
    this.router.navigate(['user-hist']);
  }

  onSideNavSelect(): void {
    this.toggleSideNav.emit();
  }

  AddEmployee()
  {
    this.tokenStorageService.saveSupervisorId(Number(this.tokenStorageService.getUserInfoId()));
    localStorage.setItem("profileusername",this.tokenStorageService.getuserFullName());
    localStorage.setItem("profiledivid",this.tokenStorageService.getDivId());
    this.router.navigate(['/directreports']);
  }


  onAddUser(): void {
    this.isAddingUser = true;
    const dialogRef = this.dialog.open(AddUserComponent, {
      disableClose: true,
      width: '70%',
    });
    dialogRef.afterClosed().subscribe(() => {
      this.isAddingUser = false;
    })
  }

  getProfileThumbnail(): void {
    this.userService.assureToken().subscribe(_usr => {
      this.userService.getPhoto(this.myUserId, 150).subscribe((baseImage: Blob) => {
        let _blob = new Blob([baseImage], { type: 'image/jpeg' });
        var objectUrl = URL.createObjectURL(_blob);
        this.myProfileImageSafe = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      });
    });
  }

  setUserInfo(info: IUserInfoViewResponse): void {
    this.myUserInfo.id = info.userInfoModel.id ? Number(info.userInfoModel.id) : null;
    this.myUserInfo.name = info.userInfoModel.username;
    this.myUserInfo.photo = info.userInfoModel ? info.userInfoModel.photo : null;
  }

}
